import GroupBookingSeatDetails from './GroupBookingSeatDetails';

export default GroupBookingSeatDetails;
